import { Form } from '~/shared/api'

export default class AgreementsSignaturesAllForm extends Form {
  email: string = ''
  phone: string = ''

  constructor(email: string = '', phone: string = '') {
    super()
    this.email = email
    this.phone = phone
  }
}
